import React, { Component, Fragment } from 'react';
import {withRouter} from 'react-router-dom';
import Loading from '../../../hoc/Loading/Loading';
import axios from '../../../axios';
import * as actionCreators from '../../../modules/actions/index';
import { connect } from 'react-redux';
import {  checkUserPrivileges, populateChartFields, getHtml2Text } from '../../../utils/constants';
import moment from 'moment';
import * as url from '../../../utils/url';
import { Card, CardBody, CardImg, CardTitle, CardText, Input, Row, Col } from "reactstrap";
import CKEditorUI from '../../../components/CKEditor/CKEditorUI';
import noAttachments from '../../../assets/upload_file.svg';
import Title from './InsightTitle';
import { deepClone } from '../../../utils/copyObject';

let placeholderTxt = 'What is your insight about this chart?'

class SingleInsight extends Component {
  constructor(props) {
    super(props);
    this.state = { 
        singleNote: this.props.selectedInsight? {...this.props.selectedInsight}:{},
        actionType: this.props.actionType,
        openCreateChartReport:this.props.openCreateChartReport,
        description: this.props.selectedInsight? this.props.selectedInsight.description:'',
        updatedFields:[],
        setImagesPreview:[],
        rejectedFiles:[],
     }
  }
  
  componentDidMount(){
    // this.getAttachedItems()
  }

  
  
  componentDidUpdate(prevProps) {
   let{openCreateChartReport}=this.props
   if(prevProps.openCreateChartReport != openCreateChartReport){
     let obj={openCreateChartReport}
     if(this.props.selectedInsight && Object.keys(this.props.selectedInsight).length>0){
       let{selectedInsight,canEdit}=this.props
        obj={...obj, singleNote:{...selectedInsight}, canEdit}
     }
     this.setState({...obj})
    }
    // (prevProps.openCreateChartReport == openCreateChartReport )&& 
  
    if( prevProps.actionType!=this.props.actionType ) {
     if(this.props.actionType=='CREATE'){
          this.setState({
            actionType:'CREATE',
            singleNote: null,
            description:''
          })
      } else{
        this.setState({actionType:this.props.actionType, canEdit:this.props.canEdit})
      }
     
    }
  }




handleChangeText = (event) => {
    let descriptionContext = event.editor.getData();
    // let{singleNote}=this.state
    // singleNote = {...singleNote, description:descriptionContext }
    // this.setState({ singleNote, description:descriptionContext })
    this.setState({ description:descriptionContext, isError:false })

} 

handleChangeInsightTitle = (event) => {
  const { value } = event.target;
  let { singleNote } = this.state
  let result = {...singleNote, name:value }
  this.setState({ singleNote:result })
}

handleClick = event => {
  const { target = {} } = event || {};
  target.value = "";
};

submitChartInsight= (insight_name) =>{
  let{setImagesPreview, description, singleNote,actionType}=this.state
  let that=this
  let isDesc = description &&  description != undefined  &&  description != null ? description.replace(/<\/?[^>]+(>|$)/g, "") : '';
  const formData = new FormData();

  if(isDesc.length>0){
    let{description}=this.state
    if(setImagesPreview && setImagesPreview.length>0){
      Array.from(setImagesPreview).forEach(itm => {
        delete itm.isAccepted
        formData.append('uploads', itm.file);
      })
    }  

    let sanitizedDesc = getHtml2Text(description)
    formData.append('chartId', this.props.chart._id)
    formData.append('chart_name', this.props.chart.name)
    formData.append('userId', this.props.user.profile._id)
    formData.append('dashboardId', this.props.reports._id)
    formData.append('orgId', this.props.user.profile.organizationId._id)
    formData.append('timestamp', new Date())
    formData.append('description',description)
    formData.append('sanitizedDesc',sanitizedDesc)
    formData.append('firstname', this.props.user.profile.firstName)
    formData.append('lastname', this.props.user.profile.lastName)

    let name=insight_name && insight_name.length>0?insight_name:''
    
    if(name){
      formData.append('name',name)
    }



  if(actionType!='EDIT'){
      axios.post(url.createChartInsight, formData, { headers: {
        'Content-Type': 'multipart/form-data'
      }}).then(({ data }) => {

        populateChartFields.map(e=>{
          delete data.data[e]
        })
        
        that.props.updateReportCharts(data.data)
        that.props.closeAddInsight(data.data.insights)
      })
  } else {
    const editformData = new FormData();
    
    if(name){
      editformData.append('name',name)
    }
    editformData.append('description',description)
    editformData.append('sanitizedDesc',sanitizedDesc)
    editformData.append('updated', new Date())
    editformData.append('insightId', singleNote._id)
    editformData.append('chartId', this.props.chart._id)
    editformData.append('chart_name', this.props.chart.name)
    editformData.append('userId', this.props.user.profile._id)
    editformData.append('dashboardId', this.props.reports._id)
    editformData.append('firstname', this.props.user.profile.firstName)
    editformData.append('lastname', this.props.user.profile.lastName)
    editformData.append('timestamp', singleNote.timestamp)

    

    axios.post(url.editChartInsight, editformData, { headers: {
      'Content-Type': 'multipart/form-data'
    }}).then(({ data }) => {

        populateChartFields.map(e=>{
          delete data.data[e]
        })
      that.props.updateReportCharts(data.data)
      that.props.closeAddInsight(data.data.insights)
    })
  }



  } else {
    this.setState({isError: true})
  }

}

openCreateChartReport=()=>{
  this.props.closeSingleInsight()
  // this.setState( prevState =>({ openCreateChartReport: !prevState.openCreateChartReport }))
}

createMarkup(html){
  return { __html: `<div>${html}</div>` };
}


changeInsightAction=(val)=>{
  if(val=='CREATE'){
    this.setState({
      singleNote:{},
      actionType:'CREATE',
      description:''
    })
  }
  if(val=='VIEW'){
    let{singleNote}=this.state
    let{title,description}=singleNote
    this.setState({
      actionType:'VIEW',
      description,
      title
    })
  }
  this.props.changeInsightAction(val)
}

renderViewOnly=()=>{
  let{singleNote}=this.state
  let{canEdit}=this.props
  console.log('canEdit: ', canEdit)
  if(singleNote && singleNote.description){
    return (
      <span className="singleInsightViewContainer">
        
        
        <span className="singleInsightViewContainerOptions">
        <span className="singleInsightViewContainerBtn btn-info">View <i className='flaticon-vision'/> </span>

        {  canEdit?
        <span>
          <span className="singleInsightViewContainerBtn btn-outline-success"
          onClick={()=>this.changeInsightAction('EDIT')}> Update <i className='flaticon-edit'/> </span>
          

           <span className="singleInsightViewContainerBtn btn-outline-primary"
          onClick={()=>this.changeInsightAction('CREATE')}> Add Insight 
            <svg className="addInsightSvg" xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" viewBox="0 0 16 16">
              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
              <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
            </svg>
          </span>  
          </span>
          :null}

          <span className="singleInsightViewContainerBtn btn-outline-secondary"
          onClick={()=>this.openCreateChartReport()}> All Insights <i className='flaticon-paper'/> </span>
        </span>
       


      <span className="singleInsightViewMainContent">
        <div className="singleInsightViewContentContainer">
            <Title actionType={"VIEW"} 
            singleNote ={singleNote}
            // name = {this.state.singleNote && this.state.singleNote.name?this.state.singleNote.name:''}
            />
            <div>
                <span className="singleInsightViewDetails text-muted">
                {singleNote.firstname} {singleNote.lastname} on {moment(singleNote.timestamp).format("MMM D, YYYY, h:mm a")} 
                {singleNote.updated!=null && singleNote.updated? <span><br/>Last updated on {moment(singleNote.updated).format("MMM D, YYYY, h:mm a")}</span>:null}
                </span>

            </div>
        </div>

        <div dangerouslySetInnerHTML={this.createMarkup(singleNote.description)} className="singleInsightViewDescription"  />                  
    
      </span>
      </span>
    )
  }
}




renderUpdate=()=>{
  let{singleNote,actionType,description,isError}=this.state
  return (
    <div className="singleInsightViewContainer" >
                        <Title 
                        actionType={actionType}
                        changeInsightAction={this.changeInsightAction}
                        singleNote ={singleNote}
                        canEdit={this.props.canEdit}
                        name = {this.state.singleNote && this.state.singleNote.name?this.state.singleNote.name:''}
                        openCreateChartReport={this.openCreateChartReport}
                        submitChartInsight={this.submitChartInsight} />
                    

                      {isError?<span className="chartInsightError">This field is required.</span>:null}
                      <div className="singleInsightAddDescriptionContent"
                      style={{border: isError?'2px solid #ff0000bf':''}}
                       >
                          <CKEditorUI
                            onChange={this.handleChangeText}
                            value={description}
                            afterPaste={this.addText}
                          />
                      </div>
                    
                      

    </div>
  )
}





renderView=()=>{
  let{ actionType}=this.state
  if(actionType=='VIEW'){
    return this.renderViewOnly()
  }  else {
   
    return this.renderUpdate()
  }
}









  render() { 
    // let{updatedFields, singleNote, setImagesPreview,openCreateChartReport,rejectedFiles}=this.state
    // let total_uploads = setImagesPreview.concat(rejectedFiles)
   let{openCreateChartReport}=this.state
    return  openCreateChartReport?this.renderView():null
 
    
  }
}




const mapStateToProps = state => {
  return {
    user: state.user,
    kpiMaster: state.kpiMaster,
    mappingMaster: state.mappingMaster,
    reports:state.reports

  }
}

const mapDispatchToProps = dispatch => {
  return {
    onKpiMasterListFetched: (data) => dispatch(actionCreators.storeKpiMaster(data)),
    onMappingMasterListFetched: (data) => dispatch(actionCreators.storeMappingMaster(data)),
    onProfileUpdate: (data) => dispatch(actionCreators.updateProfileInfoSuccess(data)),
    updateNavBar: (header) => dispatch(actionCreators.navBarUpdate(header)),
    updateReportCharts:(dashboard)=> dispatch(actionCreators.updateReportCharts(dashboard)),

  }
}
 
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Loading(SingleInsight, axios)));



